import * as z from 'zod'

export const editRateSchema = z.object({
  hourlyRateDollars: z
    .number({
      required_error: 'Rate is required',
      invalid_type_error: 'Must be a number',
    })
    .positive('Must be greater than 0'),
  note: z.string().optional(),
  isEnabled: z.boolean(),
})

export type EditRateSchema = z.infer<typeof editRateSchema>
